<template>
  <div>

    <form-set-generic
      v-if="section.personal.show"
      v-model="curriculum.personal"
      label="curriculum"
      form="admissional"
      section="personal"
      :fields="section.personal.fields"
      class="profile-subsection"
      autocomplete="off"
    />

    <form-set-generic
      v-if="section.diversity.show"
      v-model="curriculum.diversity"
      label="curriculum"
      form="admissional"
      section="diversity"
      :fields="section.diversity.fields"
      :title="$t('admissional.sections.personal.diversity')"
      class="profile-subsection"
      autocomplete="off"
    />

    <form-set-generic
      v-if="section.passport.show"
      v-model="curriculum.passport"
      label="curriculum"
      form="admissional"
      section="passport"
      :fields="section.passport.fields"
      :title="$t('admissional.sections.personal.passport')"
      class="profile-subsection"
      autocomplete="off"
    />

    <form-set-generic
      v-if="section.address.show"
      v-model="curriculum.address"
      label="curriculum"
      form="admissional"
      section="address"
      :fields="section.address.fields"
      :title="$t('admissional.sections.personal.address')"
      class="profile-subsection"
      autocomplete="off"
    />

    <form-set-generic
      v-if="section.education.show"
      v-model="curriculum.education"
      label="curriculum"
      form="admissional"
      section="education"
      :fields="section.education.fields"
      :title="$t('admissional.sections.personal.education')"
      class="profile-subsection"
      autocomplete="off"
    />
  </div>
</template>

<script>
import { useCurriculum } from "@state/user/curriculum";
import FormSetGeneric from "@components/forms/set/Generic.vue";

export default {
  components: {
    FormSetGeneric,
  },
  setup() {
    const curriculum = useCurriculum();
    return {
      // you can return the whole store instance to use it in the template
      curriculum,
    };
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },

  methods: {},
  watch: {},
};
</script>
